import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '../lib/utils';
import {
  MessagePlaceholder,
  MessagePlaceholderProps
} from './MessagePlaceholder';

export interface CurtainProps extends MessagePlaceholderProps {
  className?: string;
  act?: 'loading' | 'empty' | 'no-selection' | 'todo' | 'error';
  size?: 'small' | 'large';
  expectingInput?: boolean;
}

export const Curtain: FC<CurtainProps> = props => {
  const { t } = useTranslation();
  const {
    act,
    className,
    size = 'large',
    expectingInput = true,
    ...others
  } = props;
  switch (act) {
    case 'loading':
      others.title = others.title ?? t('components.Curtain.loading.title');
      break;
    case 'no-selection':
      others.text = others.text ?? t('components.Curtain.noSelection.text');
      break;
    case 'empty':
      others.title = others.title ?? t('components.Curtain.empty.title');
      others.text = expectingInput
        ? others.text ?? t('components.Curtain.empty.text')
        : '';
      break;
    case 'todo':
      others.title = others.title ?? t('components.Curtain.todo.title');
      break;
    case 'error':
      others.icon = 'alert';
      others.text = others.text ?? t('components.Curtain.error.text');
      break;
  }

  return (
    <div
      className={cn('flex size-full items-center justify-center', className)}
    >
      {size === 'large' ? (
        <MessagePlaceholder {...others} />
      ) : (
        <div className="text-center text-xs">
          {others.title && <div>{others.title}</div>}
          {others.text && <div>{others.text}</div>}
        </div>
      )}
    </div>
  );
};
